import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "fixed top-0 left-1/2 z-99999999 w-[min(440px,calc(100vw-1.5rem))] -translate-x-1/2 pt-[env(safe-area-inset-top)] pointer-events-none",
  "aria-live": "polite",
  "aria-atomic": "true"
}
const _hoisted_2 = { class: "mt-20 px-3" }
const _hoisted_3 = { class: "flex items-center gap-3 px-4 py-3 pr-10" }
const _hoisted_4 = { class: "shrink-0 flex h-6 w-6 items-center justify-center" }
const _hoisted_5 = { class: "min-w-0 flex-1" }
const _hoisted_6 = { class: "text-sm font-semibold leading-snug wrap-break-word text-center sm:text-left" }
const _hoisted_7 = { class: "h-1 w-full bg-black/5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        mode: "out-in",
        "enter-active-class": "transition ease-out duration-200",
        "enter-from-class": "opacity-0 -translate-y-2",
        "enter-to-class": "opacity-100 translate-y-0",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100 translate-y-0",
        "leave-to-class": "opacity-0 -translate-y-2",
        onAfterLeave: _ctx.onAfterLeave
      }, {
        default: _withCtx(() => [
          (_ctx.visible)
            ? (_openBlock(), _createElementBlock("div", {
                key: _ctx.toastKey,
                class: _normalizeClass(["pointer-events-auto relative overflow-hidden rounded-xl border shadow-xl ring-1 ring-black/5 backdrop-blur", _ctx.toastClasses]),
                role: "alert",
                onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pauseAutoClose && _ctx.pauseAutoClose(...args))),
                onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resumeAutoClose && _ctx.resumeAutoClose(...args)))
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["absolute right-2 top-2 z-10 inline-flex h-7 w-7 items-center justify-center rounded-lg opacity-70 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2", _ctx.closeRingClass]),
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", {
                    class: "fa-solid fa-xmark text-sm",
                    "aria-hidden": "true"
                  }, null, -1)
                ]))], 2),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-solid text-lg leading-none", _ctx.iconClass]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.localMsg), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.shouldShowProgress)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["toast-progress h-full w-full", _ctx.progressClass]),
                        style: _normalizeStyle(_ctx.progressStyle)
                      }, null, 6))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["h-full w-full", _ctx.progressClass]),
                        style: {"opacity":"0.35"}
                      }, null, 2))
                ])
              ], 34))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onAfterLeave"])
    ])
  ]))
}